.badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 24px;
  padding-inline: 10px;
  border-radius: var(--radius-pill);
  font-size: var(--text-xs);
  font-weight: 700;
  white-space: nowrap;
  /* Jamais étiré par un parent flex/grid en colonne (align-items: stretch). */
  inline-size: fit-content;
}
.neutral {
  background: var(--color-neutral-soft);
  color: var(--color-text-muted);
}
.accent {
  background: var(--color-accent-soft);
  color: var(--color-accent-ink);
}
.success {
  background: var(--color-success-soft);
  color: var(--color-success);
}
.warning {
  background: var(--color-warning-soft);
  color: var(--color-warning);
}
.danger {
  background: var(--color-danger-soft);
  color: var(--color-danger);
}
.info {
  background: var(--color-info-soft);
  color: var(--color-info);
}
.status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: var(--text-sm);
  font-weight: 500;
  white-space: nowrap;
}
.dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex: none;
}
.dotSuccess {
  background: var(--color-success-solid);
}
.dotNeutral {
  background: var(--color-neutral-solid);
}
.dotInfo {
  background: var(--color-info-solid);
}
.dotWarning {
  background: var(--color-warning-solid);
}
.dotDanger {
  background: var(--color-danger-solid);
}
.pulse {
  box-shadow: 0 0 0 0 rgba(74, 222, 154, 0.6);
  animation: pulse 2s infinite;
}
@keyframes pulse {
  70% {
    box-shadow: 0 0 0 7px rgba(74, 222, 154, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(74, 222, 154, 0);
  }
}
